import Secured from './secured-container';

export default Secured;


// WEBPACK FOOTER //
// ./src/route/secured/index.js